import request from '@/helpers/axios'
import { getFreeIntegrations } from '@/constants/apiRoutes'
import { WITHOUT_ASU } from '@/constants/integrations'
import { INTEGRATION_ZONE } from '@/constants/viewTree'
import { INFO } from '@/constants/objectStatuses'

// Integrations "Без АСУ" live only in the installation tree, so they are not
// returned by the dispatcher integrations list and are loaded separately.
export const getWithoutAsuIntegrations = async () => {
  try {
    const { data } = await request({
      url: getFreeIntegrations({ params: { integrationTypes: WITHOUT_ASU } }),
      method: 'get',
    })
    return (data || [])
      .filter((integration) => integration.integrationType === WITHOUT_ASU)
      .map((integration) => ({
        id: integration.id,
        name: integration.tenantName
          ? `${integration.tenantName} - ${integration.name}`
          : integration.name,
        installationId: integration.id,
        isSync: false,
        status: INFO,
        systemType: WITHOUT_ASU,
        dateOfSynchronization: null,
        type: INTEGRATION_ZONE,
        parentId: WITHOUT_ASU,
        integrationOption: true,
      }))
  } catch (error) {
    console.error('Ошибка при получении интеграций без АСУ:', error)
    return []
  }
}
